import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';
import { Modality, getModalityIcon } from '~/domain/dicom/modality';

type BlendImageProps = {
    label: string | ReactNode;
    modality: Modality;
};

export default function DatasetHeader({ label, modality }: BlendImageProps) {
    return (
        <Box
            display="flex"
            gap={0.5}
            alignItems="center"
            sx={(theme) => ({
                color: theme.palette.primary.main,
            })}
        >
            {getModalityIcon(modality, 12)}
            <Typography fontSize={12} color="primary">
                {label}
            </Typography>
        </Box>
    );
}
